module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-7.492f7919.png";